import React, { SVGProps } from "react";

export const AdinThree = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={155}
      height={156}
      viewBox="0 0 155 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={77.8357}
        cy={77.9787}
        r={77.0539}
        fill="white"
        fillOpacity={0.59}
      />
      <g clipPath="url(#clip0_3218_4921)">
        <path
          d="M83.6606 43.6006V52.4374H103.735V72.3222H112.213V43.6006H83.6606Z"
          fill="#169FED"
        />
        <path
          d="M43.4575 72.3222H51.9357V52.4374H72.0062V43.6006H43.4575V72.3222Z"
          fill="#169FED"
        />
        <path
          d="M103.735 103.519H83.6606V112.355H112.213V83.6338H103.735V103.519Z"
          fill="#169FED"
        />
        <path
          d="M51.9357 83.6338H43.4575V112.355H72.0062V103.519H51.9357V83.6338Z"
          fill="#169FED"
        />
        <path
          d="M103.714 72.3223H83.7197V83.6348H103.714V72.3223Z"
          fill="#169FED"
        />
        <path
          d="M72.0064 72.3223H52.0122V83.6348H72.0064V72.3223Z"
          fill="#169FED"
        />
      </g>
      <defs>
        <clipPath id="clip0_3218_4921">
          <rect
            width={68.7558}
            height={68.7558}
            fill="white"
            transform="translate(43.4575 43.6006)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
